<template>
  <div class="colBox">
    <div class="colTit">{{ newslistData.module_name }}</div>
    <ul class="newslist">
      <li v-for="item in newslistData.informations" :key="item.id">
        <!-- <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.v1.video" :href="{{ item.infoType | getHrefUrl(item.link) }}"> -->
        <a :href="item.infoType | getHrefUrl(item.link) ">
          <div class="pic">
            <van-image :src="item.cover" />
          </div>
          <div class="txt">
            <div class="title van-multi-ellipsis--l2">
              {{ item.title }}
            </div>
            <div class="company van-ellipsis">{{ item.source }}</div>
          </div>
        </a>
      </li>
      
    </ul>
    <a
      href="https://a.app.qq.com/o/simple.jsp?pkgname=com.v1.video"
      class="more"
      >查看全部</a
    >
  </div>
</template>
<script>
import { Image as VanImage } from "vant";

export default {
  name: "newslist", //图文列表
  props: ["newslistData"],
  components: { VanImage },
  data() {
    return {};
  },
  filters:{
    getHrefUrl(infoType,link=''){
      let url = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.v1.video'
      if (infoType == 1) {
        url = link
      } else if (infoType == 2) {
        url = "http://share.v1.cn/share-video?id=" + link
      }
      return url
    }
  },
  methods: {},
  mounted() {},
};
</script>
<style scoped>
.txt {
  overflow: hidden;
  height: 75px;
}
.title {
  height: 36px;
  margin-bottom: 19px;
  color: #333333;
  overflow: hidden;
  line-height: 18px;
}
.company {
  height: 20px;
  color: #999999;
}
</style>